import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, AlertTriangle, Mail } from "lucide-react";


export default function Unsubscribed() {
    const location = useLocation();
    const query = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const already = query.get("already") === "1";
    const err = query.get("err");
    const ok = query.get("ok") === "1" || (!already && !err);

    return (
        <div
            data-testid="unsubscribed-page"
            className="min-h-screen bg-[var(--color-bg)] text-text-main flex items-center justify-center px-4"
        >
            <div className="max-w-lg w-full rounded-2xl border border-[var(--color-border)] bg-[var(--color-card)] p-8 md:p-10">
                <div className="flex items-center gap-3 mb-5">
                    {err ? (
                        <AlertTriangle className="h-8 w-8 text-[var(--color-alert)]" />
                    ) : (
                        <CheckCircle2 className="h-8 w-8 text-[var(--color-success)]" />
                    )}
                    <h1 className="text-2xl md:text-3xl font-semibold tracking-tight">
                        {err
                            ? "Unsubscribe link expired"
                            : already
                                ? "Already unsubscribed"
                                : "You've been unsubscribed"}
                    </h1>
                </div>
                <p className="text-sm text-text-secondary leading-relaxed mb-4">
                    {err && (
                        "That unsubscribe link is invalid or has expired. If you keep receiving lifecycle emails you didn't ask for, reply to any of them and we'll remove you manually."
                    )}
                    {already && (
                        "This link has already been used. Your email is already on the do-not-send list — no further emails will be delivered."
                    )}
                    {ok && (
                        "You will no longer receive lifecycle emails from Global Lead Suite. Transactional emails (receipts, security notices) are unaffected — those are legally required."
                    )}
                </p>
                <p className="text-xs text-text-secondary mb-6">
                    Changed your mind? Contact{" "}
                    <a
                        href="mailto:support@globalleadsuite.example"
                        className="text-[var(--color-primary)] hover:underline"
                        data-testid="unsubscribed-support-link"
                    >
                        support@globalleadsuite.example
                    </a>{" "}
                    to re-enable lifecycle emails on your account.
                </p>
                <div className="flex items-center gap-2">
                    <Link
                        to="/"
                        data-testid="unsubscribed-back-home"
                        className="text-xs rounded-full bg-white hover:bg-[#EDEDED] text-black px-5 py-2 font-medium inline-flex items-center gap-2"
                    >
                        Back to homepage
                    </Link>
                    <a
                        href="mailto:support@globalleadsuite.example"
                        className="text-xs rounded-full border border-[var(--color-border)] text-text-secondary hover:text-text-main px-4 py-2 inline-flex items-center gap-2"
                    >
                        <Mail className="h-3 w-3" /> Contact support
                    </a>
                </div>
            </div>
        </div>
    );
}
